import { render } from "./SettingsClinic.vue?vue&type=template&id=4377ff05&scoped=true"
import script from "./SettingsClinic.vue?vue&type=script&lang=js"
export * from "./SettingsClinic.vue?vue&type=script&lang=js"

import "./SettingsClinic.vue?vue&type=style&index=0&id=4377ff05&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4377ff05"]])

export default __exports__